import {
    computed,
    Directive,
    effect,
    inject,
    input,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';
import {
    FeatureFlagService,
    type FeatureFlag as FeatureFlagName,
} from '@quipex/core/config';

@Directive({
    selector: '[qpxFeatureFlag]',
})
export class FeatureFlag {
    private readonly templateRef = inject(TemplateRef);
    private readonly viewContainer = inject(ViewContainerRef);
    private readonly featureFlagService = inject(FeatureFlagService);

    public readonly flagName = input.required<FeatureFlagName>({
        alias: 'qpxFeatureFlag',
    });
    public readonly defaultValue = input<boolean>(false, {
        alias: 'qpxFeatureFlagDefaultValue',
    });

    private readonly isEnabled = computed(() =>
        this.featureFlagService.isFeatureEnabled(
            this.flagName(),
            this.defaultValue()
        )
    );
    private hasView = false;

    constructor() {
        effect(() => {
            this.render(this.isEnabled());
        });
    }

    private render(isEnabled: boolean): void {
        if (isEnabled && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
            return;
        }

        if (!isEnabled && this.hasView) {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}
